import { useEffect } from 'react'
import { useSettings } from 'core/hooks/useSettings'

const scripts = {
  development: {
    scriptURL: 'https://ui.s.unit.sh/release/1.10.2/components.js'
  },
  production: {
    scriptURL: 'https://ui.unit.co/release/1.10.2/components.js'
  }
}

const useUnitScript = () => {
  const {
    data: {
      featureFlags: { ENABLE_EVERLANCE_PAYMENTS }
    }
  } = useSettings()

  useEffect(() => {
    if (!ENABLE_EVERLANCE_PAYMENTS) return
    const env = process.env.REACT_APP_API_BASE_URL.startsWith(
      'https://api.everlance.com'
    )
      ? 'production'
      : 'development'
    const { scriptURL } = scripts[env]
    if (scriptURL) {
      const script = document.createElement('script')
      script.src = scriptURL
      script.async = true

      script.onload = () => {
        // Script has loaded, you can use it now.
      }
      document.head.appendChild(script)
    }
  }, [ENABLE_EVERLANCE_PAYMENTS])

  return null
}

export default useUnitScript
